import React from "react";
import ReactDOM from "react-dom/client";
import Map from "../components/dynamicMap/Map";

export default () => {
  const element = document.getElementById("map-root");
  if (!element) return;

  if (
    !element.dataset.gcp ||
    !element.dataset.resources ||
    !element.dataset.sites ||
    !element.dataset.basePath ||
    !element.dataset.mapCenter
  )
    return;

  ReactDOM.createRoot(element).render(
    <Map
      gcp={JSON.parse(element.dataset.gcp)}
      resources={JSON.parse(element.dataset.resources)}
      sites={JSON.parse(element.dataset.sites)}
      basePath={element.dataset.basePath}
      mapCenter={JSON.parse(element.dataset.mapCenter)}
    />,
  );
};
